import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { DailyTaskDetailReportTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DailyTaskDetailReportschemaObject } from "../DailyTaskDetailReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _, { forEach, toPath } from 'lodash';
import MaterialTable from "material-table";
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Grid } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = "SUNDRYFACTORYSUMMARTREPORT";
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});
export function SundryFactorySummaryReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]); 
    const [divisions, setDivisions] = useState([]);
    const [fields, setFields] = useState([]);
    const [taskCategory, setTaskCategory] = useState();
    const [labourTask, setLabourTask] = useState()
    const [gtnnumber, setGtnnumber] = useState([]);
    const [totalCount, setTotalCount] = useState();
    const [isTableHide, setIsTableHide] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);

    const [dailyTaskDetailReport, setDailyTaskDetailReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fieldID:"0",
        searchDate: "",
        category: "0",
        task: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        searchDate: "",
        category: "0",
        task: "0"
    })
    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(DailyTaskDetailReportschemaObject).options({ allowUnknown: true });
    const contentRowNames = ["collectionPointName","estateTaskCategory", "taskName", "taskCount"]
    const csvHeaders = [
        { label: "Collection Point", value: "collectionPointName" },
        { label: "Task Category", value: "estateTaskCategory" },
        { label: "Task", value: "taskName" },
        { label: "Task Count", value: "taskCount" },
    ];

    const [reportData, setReportData] = useState([]);
    const [reportDataOne, setReportDataOne] = useState([]);
    const [keys, setKeys] = useState([]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),

        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
            getTaskNames(),

        )
    }, [dailyTaskDetailReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
            getTaskNames(),

            //getLabourTask()
        )
    }, [dailyTaskDetailReport.estateID])

    useEffect(() => {
        trackPromise(
            getFieldsForDropDown(),
            getTaskNames(),

            //getLabourTask()
        )
    }, [dailyTaskDetailReport.divisionID])

    useEffect(() => {
        trackPromise(
            getGtnNumberForDropDown()
        )
    }, [dailyTaskDetailReport.searchDate])

    useEffect(() => {
        trackPromise(
            getLabourTask()
        )
    }, [dailyTaskDetailReport.category])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0"

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            divisionID: target.value,
            fieldID: "0"

        });
    }

    function handleFieldChange(target) {
        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            fieldID: target.value

        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            searchDate: target.value

        });
    }

    function handleGtnChange(target) {

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            gtnnumber: target.value

        });
    }
    function handleCategoryChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            divisionID: target.value,
            category: "0"

        });
    }


    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyTaskDetailReportschemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUNDRYFACTORYSUMMARYREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                groupID: token.groupID
            });

        } else {
            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }


    function destroyDataTable() {
        keys.forEach(e => {
            $(`#${e}`).DataTable().destroy();
        })
    }

    function createDataTable() {
        keys.forEach(e => {
            $(`#${e}`).DataTable();
        })
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(dailyTaskDetailReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(dailyTaskDetailReport.estateID);
        setDivisions(data);
    }

    async function getFieldsForDropDown() {
        const data = await services.getFieldsByDivisionID(parseInt(dailyTaskDetailReport.divisionID));
        setFields(data);
    }

    async function getTaskNames() {
        const result = await services.getAllTaskNames(dailyTaskDetailReport.groupID, dailyTaskDetailReport.estateID);
        setTaskCategory(result);
    }

    async function getLabourTask() {
        const result = await services.getLabourTaskByOperationEntityIDTaskCategoryID(dailyTaskDetailReport.estateID, dailyTaskDetailReport.category)
        setLabourTask(result)
    }


    async function getGtnNumberForDropDown() {
        const data = await services.getGtnNumberByCollectionPointIDandDate(dailyTaskDetailReport);
        setGtnnumber(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.type === "checkbox" ? target.checked : target.value;
        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            [e.target.name]: value,
        });
    }


    async function handleSearch(e) {

        e.preventDefault();

        setIsTableHide(true);

        setButtonHide(true);

        getSelectedDropdownValuesForReport(dailyTaskDetailReport);

        setIsTableHide(true);
        const result = await services.getDailyTaskDetailReportData(dailyTaskDetailReport);
        const totalCount = result.reduce((taskCount, item) => taskCount + item.taskCount, 0)
        setTotalCount(totalCount);
        let groupedResult = groupByGtn(result);
        let keys = Object.keys(groupedResult);

        setKeys(keys);
        setReportData(result);
        setReportDataOne(groupedResult);

        if (result.length > 0) {
            result.forEach(x => {
                x.startTime = moment(x.startTime).format('h:mm:ss a');
                x.endTime = moment(x.endTime).format('h:mm:ss a');
            })
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }


        setButtonHide(false);
        setIsReportButtonsEnabled();

        const comlpeteData = [...result];
        setCsvData(comlpeteData)
    }

    function createFile() {
        var settings = {
            sheetName: 'Sundry Factory Summary List',
            fileName: 'Sundry/FactorySummaryReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            collectionPointName: "Total",
            taskCount: totalCount
        }
        var newRow2 = {
            collectionPointName: "Group :" + groups[dailyTaskDetailReport.groupID],
            taskName: "Operation Entity : " + estates[dailyTaskDetailReport.estateID],
            estateTaskCategory: "Collection Point : " + divisions[dailyTaskDetailReport.divisionID == undefined]  ? "All Collection Points" :  divisions[dailyTaskDetailReport.divisionID],
            taskCount: "Category: " + taskCategory[dailyTaskDetailReport.category == undefined ] ? "All Categories" :  divisions[dailyTaskDetailReport.category],
            //fieldName: "Generated user : " + tokenService.getUserNameFromToken()
        }
        copyOfCsv.push(newRow1)
        copyOfCsv.push({},newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            field: fields[searchForm.fieldID],
            category: taskCategory[searchForm.category],
            task: labourTask[searchForm.task],
            date: searchForm.searchDate
        })
    }

    function groupByGtn(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['gtnNumber']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null) {
            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                task: "0"
            });
        }
        else {
            var nameV = "taskID";
            var valueV = data["taskID"];

            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                task: valueV.toString()
            });
        }
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Sundry / Factory Summary Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={dailyTaskDetailReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={dailyTaskDetailReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                </div>
                                <div className="row">

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="divisionID">Collection Point</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={dailyTaskDetailReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Field</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="fieldID"
                                            id="fieldID"
                                            name="fieldID"
                                            value={dailyTaskDetailReport.fieldID}
                                            onChange={(e) => handleFieldChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="category">Category</InputLabel>
                                        <Select
                                            fullWidth
                                            id="category"
                                            name="category"
                                            value={dailyTaskDetailReport.category}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Task Category--</MenuItem>
                                            {generateDropDownMenu(taskCategory)}
                                        </Select>
                                    </div>

                                    
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="task">Task</InputLabel>
                                        <Autocomplete
                                            fullWidth
                                            id="task"
                                            options={labourTask}
                                            getOptionLabel={(option) => option.taskName}
                                            size="small"
                                            onChange={(event, value) => handleSearchDropdownChange(value)}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                        />
                                        {errors["task"] && <FormHelperText error>{errors["task"]}</FormHelperText>}
                                    </div>
                                </div>
                               

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <TableContainer component={Paper}>
                                                <Table className={classes.table} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Collection Point</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Task Category</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Task</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>Task Count</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                            <TableRow key={i}>
                                                                <TableCell component="th" scope="row" align="center"> {row.collectionPointName}</TableCell>
                                                                <TableCell component="th" scope="row" align="center"> {row.estateTaskCategory}</TableCell>
                                                                <TableCell component="th" scope="row" align="center"> {row.taskName}</TableCell> 
                                                                <TableCell component="th" scope="row" align="right"> {row.taskCount}</TableCell>

                                                            </TableRow>

                                                        )
                                                        )}

                                                    </TableBody>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                            <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                                            <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                                            <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalCount}</TableCell>
                                                        </TableRow>

                                                    </TableHead>

                                                </Table>
                                                <TablePagination
                                                    component="div"
                                                    count={reportData.length}
                                                    onChangePage={handlePageChange}
                                                    onChangeRowsPerPage={handleLimitChange}
                                                    page={page}
                                                    rowsPerPage={limit}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                />
                                            </TableContainer>
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Sundry/Factory Summary Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} dataOne={reportDataOne}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys} totalCount={totalCount} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
